import { useState } from 'react';
import axios from 'axios';

const useFetchProjectAudits = () => {
  const [loadingFetchProjectAudits, setLoadingFetchProjectAudits] = useState(false);
  const [errorFetchProjectAudits, setErrorFetchProjectAudits] = useState(null);

  const fetchProjectAudits = async () => {
    try {
      setLoadingFetchProjectAudits(true);
      setErrorFetchProjectAudits(null);

      const response = await axios.get(`/api/Audit/project-audits`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      setErrorFetchProjectAudits(err instanceof Error ? err.message : 'An error occurred');
      throw err;
    } finally {
      setLoadingFetchProjectAudits(false);
    }
  };

  return { fetchProjectAudits, loadingFetchProjectAudits, errorFetchProjectAudits };
};

export default useFetchProjectAudits;
